import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Icon from 'atomic/icon';
import classNames from 'classnames';

import './accordion.scss';

interface AccordionProps {
    activeTab: number | null;
    handleToggle: (index: number) => void;
    label: string | ReactElement;
    index: number;
    contentContainerTagName?: 'div' | 'li' | 'span';
    children: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
    label,
    activeTab,
    handleToggle,
    index,
    children,
    contentContainerTagName = 'li'
}) => {
    const [height, setHeight] = useState(0);
    const contentEl = useRef<HTMLDivElement | null>(null) as React.MutableRefObject<HTMLDivElement>;

    useEffect(() => {
        setHeight(contentEl.current.scrollHeight);
    }, [setHeight]);

    return (
        <>
            {React.createElement(
                contentContainerTagName,
                {
                    className: classNames({
                        'accordion': true,
                        'accordion--first': index === 0
                    })
                },
                (
                    <>
                        <div className="accordion__header">
                            <div
                                className={classNames({
                                    'toggle': true,
                                    'toggle--active': activeTab === index
                                })}
                                onClick={(): void => handleToggle(index)}
                            >
                                <div className="title">
                                    {label}
                                </div>
                                <Icon
                                    name="chevron-down"
                                    color="dark"
                                    size={18}
                                />
                            </div>
                        </div>
                        <div
                            ref={contentEl}
                            className={classNames({
                                'accordion__collapse': true,
                                'accordion__collapse--show': activeTab === index
                            })}
                            style={activeTab === index ? { height } : { height: '0' }}
                        >
                            <div className="body">
                                {children}
                            </div>
                        </div>
                    </>
                )
            )}
        </>
    );
};

export default Accordion;
